function InfoItem({ name, subtitle, status, flag, href }) {
  const Component = href ? "a" : "div";

  return (
    <Component
      className="cert-item"
      href={href}
      target={href ? "_blank" : undefined}
      rel={href ? "noopener noreferrer" : undefined}
    >
      {flag ? (
        <div className="language-flag">{flag}</div>
      ) : (
        <div
          className={status === "Completed" ? "cert-dot" : "cert-dot pending"}
        />
      )}

      <div>
        <div className="cert-name">{name}</div>
        <div className="cert-source">{subtitle}</div>
      </div>

      {status && (
        <div
          className={
            status === "Completed" ? "cert-badge" : "cert-badge pending"
          }
        >
          {status}
        </div>
      )}
    </Component>
  );
}

export default InfoItem;
